import React, { useEffect, useState } from "react";
import "./unitDeptListPage.scss";
import { IonGrid, IonPage, IonRow } from "@ionic/react";

import { unitDeptListResultInterface } from "./UnitDept.modal";
import { useHistory } from "react-router-dom";
import ListCardComponent from "../../components/Shared/ListCard/listCard";
import { unitDeptListService } from "./UnitDept.service";
import Loader from "../../components/Shared/Loader/Loader";
import { useTranslation } from "react-i18next";

interface PropsInterface {
  location: {
    state: any;
  };
}

const UnitDeptListPage: React.FC<PropsInterface> = (Props: PropsInterface) => {
  const nextPage = "beds";
  let history = useHistory();
  const { t } = useTranslation("sites");

  var [UnitListData, setUnitListData]: any = useState([]);
  var [DeptListData, setDeptListData]: any = useState([]);

  const [active, setActive] = useState("units");
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);

  useEffect(() => {
    fetchUnitDeptDetails();
  }, []);

  async function fetchUnitDeptDetails() {
    setShowLoader(true);
    const respUnitDeptListResult: unitDeptListResultInterface =
      await unitDeptListService.getUnitDeptListData();
    if (respUnitDeptListResult.isSuccess) {
    } else {
      console.log("error");
      unitDeptListService.handleErrorResponse();
    }
    setUnitListData(respUnitDeptListResult.unitListResult);
    setDeptListData(respUnitDeptListResult.deptListResult);
    setShowLoader(false);
  }

  return (
    <IonPage className="unit-dept-list-page-container">
      {showLoader && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      <div className="title-container">
        <nav className="button-group">
          <div className="back-button-container d-flex align-items-center">
            <button
              className="icon-back icon"
              onClick={() => history.goBack()}
            ></button>
            <span className="site-name">{Props.location?.state?.siteName}</span>
          </div>
          <button
            className={active !== "units" ? "cc-btn" : "cc-btn active"}
            onClick={() => setActive("units")}
          >
         {t("units")}
          </button>
          <button
            className={active !== "departments" ? "cc-btn" : "cc-btn active"}
            onClick={() => setActive("departments")}
          >
            {t("departments")}
          </button>
        </nav>
      </div>
      <IonGrid className="unit-dept-list-grid">
        <IonRow className="list-container">
          {active === "units" &&
            (UnitListData ? (
              UnitListData.map((item: any, index: any) => (
                <ListCardComponent
                  key={item.id}
                  listData={item}
                  componentName={nextPage}
                  setParentListData={setUnitListData}
                  parentSource={"units"}
                />
              ))
            ) : (
              <div className="no-results-label">{t("noUnitsAvailable")}</div>
            ))}
          {active === "departments" &&
            (DeptListData ? (
              DeptListData.map((item: any, index: any) => (
                <ListCardComponent
                  key={item.id}
                  listData={item}
                  componentName={nextPage}
                  setParentListData={setDeptListData}
                  parentSource={"departments"}
                />
              ))
            ) : (
              <div className="no-results-label">{t("noDepartmentsAvailable")}</div>
            ))}
          {((active === "units" && UnitListData.length === 0) ||
            (active === "departments" && DeptListData.length === 0)) && (
            <div className="no-results-label">
             {t("noActiveAvailable", { type: t(active) })}
            </div>
          )}
        </IonRow>
      </IonGrid>
    </IonPage>
  );
};

export default UnitDeptListPage;
